// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { LocalI18nProvider } from './providers/local-provider';
export function I18nProvider({ locale, messages, children }) {
    useBaseComponent('I18nProvider');
    return (React.createElement(LocalI18nProvider, { locale: locale, messages: messages }, children));
}
applyDisplayName(I18nProvider, 'I18nProvider');
//# sourceMappingURL=provider.js.map